export const DEFAULT_GAME = "shillong-night-teer";

export const GAMES = [
  { slug: "my-night-teer", name: "My Night Teer", fr: "8:00 PM", sr: "9:00 PM", color: "bg-indigo-600" },
  { slug: "lucky-night-teer", name: "Lucky Night Teer", fr: "10:00 PM", sr: "11:00 PM", color: "bg-emerald-600" },
  { slug: "juwai-night-teer", name: "Juwai Night Teer", fr: "9:30 PM", sr: "10:30 PM", color: "bg-orange-500" },
  { slug: "shillong-night", name: "Shillong Night Teer", fr: "10:30 PM", sr: "11:30 PM", color: "bg-red-600" },
  { slug: "khasi-night-teer", name: "Khasi Night Teer", fr: "8:30 PM", sr: "9:30 PM", color: "bg-purple-600" },
  { slug: "guwahati-night-teer", name: "Guwahati Night Teer", fr: "9:00 PM", sr: "10:00 PM", color: "bg-blue-600" },
  { slug: "bhutan-night-teer", name: "Bhutan Night Teer", fr: "9:30 PM", sr: "10:30 PM", color: "bg-teal-600" },
  { slug: "khanapara-night-teer", name: "Khanapara Night Teer", fr: "10:00 PM", sr: "11:00 PM", color: "bg-rose-600" },
];

export const getGame = (slug) =>
  GAMES.find((g) => g.slug === slug) ||
  (slug === DEFAULT_GAME
    ? { slug: DEFAULT_GAME, name: "Shillong Night Teer", fr: "11:10 PM", sr: "12:10 AM" }
    : { slug: slug || DEFAULT_GAME, name: "Night Teer", fr: "", sr: "" });

// Main homepage flagship result (managed manually from the admin panel). Not shown as a grid card.
export const FLAGSHIP = { slug: DEFAULT_GAME, name: "Shillong Night (Main Homepage)", fr: "11:10 PM", sr: "12:10 AM", color: "bg-red-600" };

// Games available in the admin panel: flagship first, then all grid games.
export const ADMIN_GAMES = [FLAGSHIP, ...GAMES];
